import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, ModuleWithProviders, NgModule } from '@angular/core';
import { provideNamedApollo } from 'apollo-angular';

import { ApolloCacheManager } from './apollo-cache-manager.service';
import { ApolloConnectionService } from './apollo-connection.service';
import { APOLLO_TYPE_POLICY_PROVIDERS } from './apollo-type-policy.provider';
import { SysApiTypePolicyProvider } from './sys-api';

@NgModule({
	providers: [
		provideHttpClient(withInterceptorsFromDi()),
		provideNamedApollo(() => {
			const connectionService = inject(ApolloConnectionService);
			return {
				sysApi: connectionService.createApolloClientOptions()
			};
		})
	]
})
export class ApolloSysApiCloudModule {
	public static forRoot(): ModuleWithProviders<ApolloSysApiCloudModule> {
		return {
			ngModule: ApolloSysApiCloudModule,
			providers: [
				ApolloCacheManager,
				{
					provide: APOLLO_TYPE_POLICY_PROVIDERS,
					multi: true,
					useClass: SysApiTypePolicyProvider
				}
			]
		};
	}
}
